import { COUNTRIES, COUNTRY_ORDER } from "@orvis/config";
import { commitCountryChoice } from "../config.js";

/**
 * First-run country picker. Rendered when the app boots and no country
 * has been remembered / passed / baked. On selection, the choice is
 * written to localStorage and the page reloads — cheaper than plumbing
 * a swap through every provider.
 */
export function CountryPicker() {
  return (
    <div className="min-h-dvh bg-bg text-text flex items-center justify-center p-6">
      <div className="w-full max-w-md space-y-6">
        <div className="space-y-2 text-center">
          <h1 className="text-2xl font-semibold">Orvis</h1>
          <p className="text-text/70">Choose your country</p>
        </div>

        <div className="space-y-3">
          {COUNTRY_ORDER.map((code) => {
            const country = COUNTRIES[code];
            if (!country) return null;
            return (
              <button
                key={code}
                type="button"
                onClick={() => commitCountryChoice(code)}
                className={
                  "w-full flex items-center gap-4 p-4 rounded-lg " +
                  "border border-border bg-card hover:border-accent focus-visible:border-accent " +
                  "transition-colors text-left"
                }
              >
                <span className="text-3xl leading-none" aria-hidden>
                  {country.flag ?? "🌐"}
                </span>
                <span className="flex-1 font-medium">{country.name}</span>
                <span className="text-text/40 text-sm uppercase">{country.code}</span>
              </button>
            );
          })}
        </div>

        <p className="text-xs text-text/50 text-center">
          You can change this later from the header.
        </p>
      </div>
    </div>
  );
}
